// Calls to the backend (same site, /api). The session lives in an httpOnly cookie, so no token is handled here.
const BASE = process.env.REACT_APP_BACKEND_URL || "";

export class ApiError extends Error {
  constructor(message, status) {
    super(message);
    this.status = status;
  }
}

export async function api(path, { method = "GET", body } = {}) {
  let res;
  try {
    res = await fetch(`${BASE}/api${path}`, {
      method,
      credentials: "same-origin",
      // The backend refuses changes without this header (another website's form can't add it)
      headers: { "Content-Type": "application/json", "X-BEE-Request": "1" },
      body: body === undefined ? undefined : JSON.stringify(body),
    });
  } catch {
    throw new ApiError("Could not reach the server. Please check your internet connection and try again.", 0);
  }
  let data = null;
  try {
    data = await res.json();
  } catch {
    // empty or non-JSON body
  }
  // The session ended (8 hours, or the administrator changed the account) while on any page: a fresh
  // reload of the front address, which shows the sign-in page (owner, 2026-10-10). Not for the sign-in
  // calls themselves - a wrong password or code answers 401 too.
  if (res.status === 401 && !path.startsWith("/auth/")) {
    window.location.replace("/");
  }
  if (!res.ok) {
    const detail = typeof data?.detail === "string" ? data.detail : "Please check what you entered and try again.";
    throw new ApiError(res.status >= 500 && res.status !== 502 && res.status !== 503 ? "Something went wrong on the server. Please try again." : detail, res.status);
  }
  return data;
}

export const formatDateTime = (value) =>
  value ? new Date(value).toLocaleString("en-ZA", { dateStyle: "medium", timeStyle: "short" }) : "";
